export enum MessengerValidationTypes {
    None = 'none',
    UKPostcode = 'uk-postcode',
    USZipcode = 'us-zipcode',
    USState = 'us-state',
    EmailAddress = 'email-address',
    CharacterLimitMinimum25 = 'character-limit-minimum-25',
}
